export default __webpack_public_path__ + "static/media/ddsu5168_2p_rs485_gw152.a31b55e7.png";